module.exports = __webpack_public_path__ + "static/img/thumb_5.18003bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_5.jpg
// module id = ATZn
// module chunks = 0